// SPDX-License-Identifier: LicenseRef-Syncanix-Proprietary

/**
 * The catalog keeps the trailing `→ <name>` on both decision sentences; the
 * card is already titled with that name, so the render drops it.
 *
 * It is kept in the DATA rather than trimmed at author time on purpose — it is
 * the only marker that makes the split checkable in the five locales a reviewer
 * does not read (`comparison-content.test.ts` asserts the Syncanix half names
 * Syncanix and the rival half does not). Both arrow glyphs are matched because
 * Arabic and Hebrew correctly carry `←`.
 */
export function decisionText(sentence: string): string {
  const cut = sentence.search(/[→←]/);
  const clause = (cut === -1 ? sentence : sentence.slice(0, cut)).trim();
  // Strip the FULL STOP as well as the clause punctuation before re-adding one.
  // Without the `.` in that class a sentence carrying no marker at all came
  // back double-stopped — which is the branch that runs if a future catalog
  // edit drops the arrow, i.e. exactly when nobody is looking.
  return `${clause.replace(/[.,;:]+$/, '')}.`;
}
